<template>
  <div class="typeset-type">
    <div class="group">
      <label>{{$t('cover.labelA4Templates')}}</label>
      <div class="typeset-type-list">
        <div class="typeset-type-item A4" v-for="(template, index) in A4" :key="index"
             @click="$emit('change', template.name)">
          <cover-holder :src="template.cover" :height="coverHeight" :selected="typeset === template.name"/>
          <p>{{$t(template.label)}}</p>
        </div>
      </div>
    </div>

    <div class="group">
      <label>{{$t('cover.labelA5Templates')}}</label>
      <div class="typeset-type-list">
        <div class="typeset-type-item" v-for="(template, index) in A5" :key="index"
             @click="$emit('change', template.name)">
          <cover-holder :src="template.cover" :height="coverHeight" :selected="typeset === template.name"/>
          <p>{{$t(template.label)}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoverHolder from '../../../components/CoverHolder'

export default {
  name: 'typeset-type',
  components: { CoverHolder },
  props: {
    typeset: {
      type: String,
      default: 'a5-1'
    }
  },
  data () {
    return {
      coverHeight: 141.1
    }
  },
  computed: {
    A4 () {
      return [
        {
          name: 'a4-1',
          cover: 'https://static.ipastbook.com/assets/images/A4-1.jpg',
          label: 'book.typesetWaterfallA4'
        },
        {
          name: 'a4-2',
          cover: 'https://static.weixinshu.com/assets/img/A4-1-child.a2effa4c.jpg',
          label: 'book.typesetChildrenA4'
        }
      ]
    },
    A5 () {
      return [
        {
          name: 'a5-1',
          cover: 'https://static.ipastbook.com/assets/images/A5-1.jpg',
          label: 'book.typesetWaterfall'
        },
        {
          name: 'a5-2',
          cover: 'https://static.ipastbook.com/assets/images/A5-2.jpg',
          label: 'book.typesetColumn'
        }
      ]
    }
  },
  created () {
  }
}
</script>

<style lang="scss">
.typeset-type {
  &-list {
    display: flex;
  }

  .group {
    padding: 10px 0;

    & + .group {
      border-top: 1px solid #eee;
    }
  }

  .typeset-type-item {
    cursor: pointer;
    min-width: 6em;
    width: 33%;
    flex: 0 0 33%;
    position: relative;
    padding: 5px;
    overflow: hidden;

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: .5em;
      font-weight: 500;

      .label {
        margin-left: 4px;
      }
    }

    &.A4 {
      width: 40%;
      flex: 0 0 40%;
    }
  }
}
</style>
